import PrivateDomainTraffic from '@/pages/privateDomain/Traffic'

export default [
  {
    path: '/private-domain/traffic',
    component: PrivateDomainTraffic,
    meta: {
      title: '添加客服',
      whiteList: true
    }
  }
]
